/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Text } from '@lib/canvasx/components/Text';
import { type FieldContentsData, type PillStructure } from '../../shared-types';
import { canvasCssValue, parseColorValue } from '@lib/canvasx/util';
import { FlexRow } from '@lib/canvasx/components/FlexRow';
import { IconField } from './IconField';
import { Rect } from '@lib/canvasx/components/Rect';

export const PillField: CanvaSXFC<{
  pill: PillStructure;
  contents: FieldContentsData;
  fieldId: RecordId;
}> = function ({ pill, contents, fieldId }) {
  let { text, textColor, color, icon } = pill;

  // The field definitions might return us some CSS vars, so we need to parse those
  textColor =
    textColor === undefined
      ? canvasCssValue('--theme-primary-text', '#333')
      : parseColorValue(textColor, '#333');
  color =
    color === undefined
      ? canvasCssValue('--theme-secondary-background', '#f7f7f7')
      : parseColorValue(color, '#f7f7f7');

  return (
    <Rect margin={{ vertical: 2 }}>
      <FlexRow
        border={color}
        fill={`color-mix(in srgb, ${color} 50%, ${canvasCssValue(
          '--theme-primary-background',
          '#ffffff'
        )})`}
        borderRadius={2}
        padding={{ horizontal: 4, vertical: 2 }}
        verticalAlignment='center'
        gap={3}
      >
        {icon ? (
          <IconField
            icon={{ color: textColor, ...icon }}
            size={9}
            contents={contents}
            fieldId={fieldId}
          />
        ) : null}

        <Text color={textColor} size={9} maxWidth={200} overflow='…'>
          {text}
        </Text>
      </FlexRow>
    </Rect>
  );
};
